// extracted by mini-css-extract-plugin
module.exports = {"xs":"0","sm":"23.43rem","md":"40.06rem","lg":"63rem","xl":"80rem","rafSection":"referAFriend_rafSection___6p_c"};